export const REFERRAL_BONUS_CREDITS = 300

/** Global kill switch for referral promo UI. Keep false so the banner never appears. */
export const REFERRAL_UI_ENABLED = false
